import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Modal from "react-modal";
import Spinner from "../components/Spinner";

import "../assets/css/sidebar.css";
import "../assets/css/style.css";
import Logo from "../assets/images/logoMain.svg";
import MiniLogo from "../assets/images/Logo.svg";
import MiniLogoH from "../assets/images/logoSm.svg";
import LogoHover from "../assets/images/LogoH.svg";
import Dashboard from "../assets/images/Dashboard.svg";
import Search from "../assets/images/Search.svg";
import User from "../assets/images/User.svg";
import Jobs from "../assets/images/Jobs.svg";
import Onboarding from "../assets/images/Onboarding.svg";
import Team from "../assets/images/Team.svg";
import Templates from "../assets/images/Templates.svg";
import Inbox from "../assets/images/Inbox.svg";
import Calendar from "../assets/images/Calendar.svg";
import downarrows from "../assets/images/dropdown.svg";
import Integrations from "../assets/images/Integrations.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import UserChecked from "../assets/images/user-check 2.svg";
import Clipboard from "../assets/images/Clipboard.svg";
import Files from "../assets/images/file-plus 2.svg";
import Converter from "../assets/images/refresh-cw.svg";
import UserCheckNotSel from "../assets/images/UserCheckNotSel.svg";
import ClipboardSel from "../assets/images/Clipboard.svg";
import ConverterSelc from "../assets/images/ConverterSelc.svg";
import FilesSelec from "../assets/images/FilesSelec.svg";
import resours from "../assets/images/ress.png";

import shield from "../assets/images/shield-check.svg";

import bookopenselc from "../assets/images/bookopenselc.svg";
import bookopen from "../assets/images/bookopen.svg";
import comsoon from "../assets/images/com-icon.svg";

import Vector from "../assets/images/Vector-white.svg";
import Grouplogo from "../assets/images/Group-logo.svg";
import Alert from "../assets/images/alert-circle.svg";
import closex from "../assets/images/X.svg";

import Views from "../assets/images/vieworedit-icon.svg";
import onbro from "../assets/images/onboard-icon.png";
import veditprocess from "../assets/images/view-edit-proces-icon.png";
import createprocess from "../assets/images/create-process-icon.png";


import { API } from "../config/api";
import { ApiHelper } from "../helpers/ApiHelper";
import infos from "../assets/images/info-blue.svg";

const Sidebar = (props) => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isOnboardingSetupOpen, setIsOnboardingSetupOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      width: "45%",
      // marginRight: '-50%',
      transform: "translate(-50%, -50%)",
      boxShadow: "1px 2px #888888",
    },
  };
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const everify = () => {
    if (showEverify === false) {
      setIsOpen(true);
    }
  };

  const [toggle, setToggle] = useState(false);
  const location = useLocation();
  const [advancedToggle, setAdvancedToggle] = useState(false);
  const [showEverify, setShowEverify] = useState(null);
  const [formBuilderArrow, setFormBuilderArrow] = useState(false);

  let currentPath = location.pathname;
  useEffect(() => {
    let advanceToggle = localStorage.getItem("advanceToggle");
    let user = JSON.parse(localStorage.getItem("UserData"));
    let userAccess = JSON.parse(localStorage.getItem("UserAccess"));
    if (advanceToggle === null) {
      setAdvancedToggle(user?.advanced_mode === 0 ? false : true);
    } else {
      setAdvancedToggle(advanceToggle);
    }
    if (showEverify === null) {
      setShowEverify(userAccess?.EverifyStatus);
    }
  }, []);
  const handleClick = async () => {
    let user = JSON.parse(localStorage.getItem("UserData"));

    const formData = {
      userId: user?.id,
      advanced_mode: !advancedToggle === true ? 1 : 0,
    };
    await ApiHelper.post(API.toggleAdvance, formData)
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          console.log(resData);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    localStorage.setItem("advanceToggle", !advancedToggle === 0 ? false : true);
    setAdvancedToggle(!advancedToggle);
  };
  const toggleLogic = () => {
    setToggle(!toggle);
    props.getSidebarToggleState(toggle);
  };

  function feedback() {
    const link = document.createElement("a");
    link.href = "https://app.avenu.ai/widget/avenuonboarding?preview=1";
    link.download = "avenu";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  function recrutingNav() {
    const link = document.createElement("a");
    link.href = "https://app.avenu.ai/";
    link.download = "avenu";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const sendRequest = async () => {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const formData = {
      user_id: user.id,
    };
    await ApiHelper.post(API.sendEverifyRequest, formData)
      .then((resData) => {
        if (resData.data.success === true) {
          console.log("resData", resData);
          setIsOpen(false);
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
      });
  };
  return (
    <div>
      <nav className={!props.sidebarEnabler ? "sidebar" : " sidebar active"}>
        <div>
          <div className="d-flex wrp align-items-center logoContainer group">
            <div className="group-logo" onClick={toggleLogic}>
              <img src={Grouplogo} alt="test" className="menu_icon" />
            </div>
            <div className="ca-details  res-icon ">
              <span className="titleAv">Avenu</span>

              <div className="userarea">
                <div className="dropdown">
                  <button
                    className="btn btn-secondary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span className="rect-alignt">Onboarding</span>
                  </button>
                  <ul className="dropdown-menu mt-1 profile-width">
                    <li
                      onClick={() => {
                        recrutingNav();
                      }}
                    >
                      <Link className="dropdown-item drop-text-aligt">
                        Recruiting
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/*<div className="bttn-logo">
                            <button class="btn btn-primary dropdown-toggle logo-bttn " type="button" data-toggle="dropdown">
                                <span class="caret"></span></button>
                        </div>*/}
          </div>

          {/*<div className="d-flex wrp align-items-center logoContainer group" >
                        <div className="group-logo" onClick={toggleLogic}>
                            <img src={Grouplogo} alt="test" className="menu_icon" />
                        </div>
                        <div className="ca-details  res-icon ">
                            <span className='titleAv'>Avenu</span>
                            <span>Onboarding</span>
                            <div className='userarea'>
                <div className="dropdown">
                    <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">

                        <span className='rect-alignt'>Onboarding</span>
                    </button>
                    <ul className="dropdown-menu mt-1 profile-width">
                        <li onClick={()=>{recrutingNav()}}><Link className="dropdown-item drop-text-aligt" >Recruiting</Link></li>
                    </ul>
                </div>
            </div>







                        </div>

                        {/*<div className="bttn-logo">
                            <button class="btn btn-primary dropdown-toggle logo-bttn " type="button" data-toggle="dropdown">
                                <span class="caret"></span></button>
                        </div>
                    </div>*/}
          {/*<div className='logoContainer ' onClick={toggleLogic}>
                <img className='hvH' src={!props.sidebarEnabler ? Logo : MiniLogo} />
                <img className='hvr' src={!props.sidebarEnabler ? LogoHover : MiniLogoH} />
            </div>*/}
          <div>
            <div className="first-ul">
              <ul
                className="nav accordion accordion-flush"
                id="accordionFlushExample"
              >
                <li>
                  <Link
                    className={
                      currentPath === "/dashboard/candidates"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="candidates"
                    onClick={() => {
                      localStorage.setItem("isOnboarding", true);
                    }}
                  >
                    {currentPath === "/dashboard/candidates" ? (
                      <span className="menuIcon_bx">
                        <img
                          src={UserChecked}
                          alt="test"
                          className="menu_icon"
                        />
                      </span>
                    ) : (
                      <span className="menuIcon_bx">
                        <img
                          src={UserChecked}
                          alt="test"
                          className="menu_icon"
                        />
                      </span>
                    )}
                    <span className="menu-title">Onboarding</span>
                  </Link>
                </li>
              </ul>
            </div>
            {advancedToggle && (
              <ul
                className="nav accordion accordion-flush"
                id="accordionFlushExample"
              >
                {/* <li>
                  <Link
                    className={
                      currentPath === "/dashboard/onboarding/edit-forms"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="/dashboard/onboarding/edit-forms"
                  >
                    {currentPath === "/dashboard/onboarding/edit-forms" ? (
                      <span className="menuIcon_bx">
                        <img
                          src={ClipboardSel}
                          alt="test"
                          className="menu_icon"
                        />
                      </span>
                    ) : (
                      <span className="menuIcon_bx">
                        <img
                          src={ClipboardSel}
                          alt="test"
                          className="menu_icon"
                        />
                      </span>
                    )}
                    <span className="menu-title">Onboarding Setup

                        {isDropdownOpen ? (
                            <img
                              src={downarrows}
                              alt="test"
                              className="arrowrrs-img arrowrrs-rotate bulider-arrw-rotate-im"
                            />
                          ) : (
                            <img
                              src={downarrows}
                              alt="test"
                              className="arrowrrs-img bulider-arrw"
                            />
                          )}
                        </span>
                      </button>
                      {isDropdownOpen && (
                        <ul className="dropdown-contentside form-menus">
                          <li>
                            <Link
                              className={
                                currentPath ===
                                  "/dashboard/onboarding/create-form" ||
                                currentPath ===
                                  "/dashboard/onboarding/edit-form"
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              to="/dashboard/onboarding/create-form"
                            >
                              Create Form
                            </Link>
                          </li>
                          <li>
                            <Link
                              className={
                                currentPath ===
                                "/dashboard/onboarding/templates"
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              to="/dashboard/onboarding/templates"
                            >
                              Manage Forms
                            </Link>
                          </li>
                        </ul>
                      )}
                    </li> */}

                <li>
                  <Link className="nav-link">
                    {/*<span className="menu-title">Form Builder</span>*/}

                    <li className="dropdown">
                      <button
                        className="dropdown-btn menu-title"
                        onClick={() => {
                          setIsOnboardingSetupOpen(!isOnboardingSetupOpen);
                        }}
                      >
                        {currentPath === "/dashboard/onboarding/edit-forms" ? (
                          <span className="menuIcon_bx">
                            <img
                              src={ClipboardSel}
                              alt="test"
                              className="menu_icon"
                            />
                          </span>
                        ) : (
                          <span className="menuIcon_bx">
                            <img
                              src={ClipboardSel}
                              alt="test"
                              className="menu_icon"
                            />
                          </span>
                        )}
                        <span className="menu-title arrows-btwn bulider-arrw-img">
                          Onboarding Process
                          {isOnboardingSetupOpen ? (
                            <img
                              src={downarrows}
                              alt="test"
                              className="arrowrrs-img arrowrrs-rotate bulider-arrw-rotate-im"
                            />
                          ) : (
                            <img
                              src={downarrows}
                              alt="test"
                              className="arrowrrs-img bulider-arrw"
                            />
                          )}
                        </span>
                      </button>
                      {isOnboardingSetupOpen && (
                        <ul className="dropdown-contentside form-menus">
                          <li>
                            
                        


                            <Link
                              className={
                                currentPath ===
                                "/dashboard/onboarding/edit-forms"
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              to="/dashboard/onboarding/edit-forms"
                            >
                           <span className="menuIcon_bx">
                            <img src={onbro} alt="test" className="menu_icon  sub-iicons" />
                          </span>

                          <span className="menu-title"> Onboarding Setup (old)</span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              className={
                                currentPath ===
                                "/dashboard/onboarding/new-onboarding-template"
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              to="/dashboard/onboarding/new-onboarding-template"
                            >
                              <span class="new-spans ml-2">
                                <p class="new-letter-side ">NEW</p>
                              </span>
                              <span className="menuIcon_bx">
                            <img src={createprocess} alt="test" className="menu_icon sub-iicons" />
                          </span>
                          <span className="menu-title">Create Process</span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              className={
                                currentPath ===
                                "/dashboard/onboarding/onboarding-templates"
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              to="/dashboard/onboarding/onboarding-templates"
                            >
                              <span class="new-spans ml-2">
                                <p class="new-letter-side-2 ">NEW</p>
                              </span>

                              <span className="menuIcon_bx">
                            <img src={veditprocess} alt="test" className="menu_icon sub-iicons" />
                          </span>

                          <span className="menu-title">View/Edit Processes</span>
                            </Link>
                          </li>
                        </ul>
                      )}
                    </li>
                  </Link>
                </li>

                <li>
                  <Link className="nav-link">
                    {/*<span className="menu-title">Form Builder</span>*/}

                    <li className="dropdown">
                      <button
                        className="dropdown-btn menu-title"
                        onClick={toggleDropdown}
                      >
                        {currentPath === "/dashboard/onboarding/create-form" ||
                        currentPath === "/dashboard/onboarding/edit-form" ? (
                          <span className="menuIcon_bx">
                            <img src={Files} alt="test" className="menu_icon sub-iicons" />
                          </span>
                        ) : (
                          <span className="menuIcon_bx">
                            <img src={Files} alt="test" className="menu_icon " />
                          </span>
                        )}
                        <span className="menu-title arrows-btwn bulider-arrw-img">
                          Form Builder
                          {isDropdownOpen ? (
                            <img
                              src={downarrows}
                              alt="test"
                              className="arrowrrs-img arrowrrs-rotate bulider-arrw-rotate-im"
                            />
                          ) : (
                            <img
                              src={downarrows}
                              alt="test"
                              className="arrowrrs-img bulider-arrw"
                            />
                          )}
                        </span>
                      </button>
                      {isDropdownOpen && (
                        <ul className="dropdown-contentside form-menus">
                          <li>
                            <Link
                              className={
                                currentPath ===
                                  "/dashboard/onboarding/create-form" ||
                                currentPath ===
                                  "/dashboard/onboarding/edit-form"
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              to="/dashboard/onboarding/create-form"
                            >

                    <span className="menuIcon_bx">
                        <img
                          src={ClipboardSel}
                          alt="test"
                          className="menu_icon sub-iicons"
                        />
                      </span>


                      <span className="menu-title">Create Form</span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              className={
                                currentPath === "/dashboard/upload"
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              to="/dashboard/upload"
                            >
                              {currentPath === "/dashboard/upload" ? (
                                <span className="menuIcon_bx">
                                  <img
                                    src={Converter}
                                    alt="test"
                                    className="menu_icon sub-iicons"
                                  />
                                </span>
                              ) : (
                                <span className="menuIcon_bx">
                                  <img
                                    src={Converter}
                                    alt="test"
                                    className="menu_icon sub-iicons"
                                  />
                                </span>
                              )} 
                               <span className="menu-title">Convert PDF</span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              className={
                                currentPath ===
                                "/dashboard/onboarding/templates"
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              to="/dashboard/onboarding/templates"
                            >
                               <span className="menuIcon_bx">
                            <img src={Views} alt="test" className="menu_icon sub-iicons" />
                          </span>
                          <span className="menu-title"> View/Edit Forms</span>
                            </Link>
                          </li>
                        </ul>
                      )}
                    </li>
                  </Link>
                </li>

                <li>
                  <Link
                    className={
                      currentPath === "/dashboard/resorces"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="/dashboard/resources"
                  >
                    {currentPath === "/dashboard/upload" ? (
                      <span className="menuIcon_bx">
                        <img src={resours} alt="test" className="menu_icon" />
                      </span>
                    ) : (
                      <span className="menuIcon_bx">
                        <img src={resours} alt="test" className="menu_icon" />
                      </span>
                    )}
                    <span className="menu-title">Resources</span>
                  </Link>
                </li>
              </ul>
            )}
            {/* <hr /> */}
            <div className="second-ul">
              <ul className="nav accordion-flush">
                <li>
                  <Link
                    className={
                      currentPath === "/dashboard/onboarding/my-team"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="/dashboard/onboarding/my-team"
                    onClick={() => {
                      localStorage.setItem("isOnboarding", false);
                    }}
                  >
                    <span className="menuIcon_bx">
                      <img src={comsoon} alt="test" className="menu_icon" />
                    </span>
                    {/* <span class="new-spans ml-2">
                      <p class="new-letter-side-2 ">NEW</p>
                    </span> */}
                    <span className="menu-title">My Team</span>
                  </Link>
                </li>
                <li>
                  <Link
                    className={
                      currentPath === "/dashboard/everify"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    onClick={everify}
                    to={showEverify === true && "/dashboard/everify"}
                  >
                    <span className="menuIcon_bx">
                      <img src={shield} alt="test" className="menu_icon" />
                    </span>
                    <span className="menu-title">Everify Cases</span>
                  </Link>
                </li>

                {/*<li >
                                     <Link className="nav-link">
                                        <span className="menuIcon_bx"><img src={comsoon} alt="test" className="res_icon" /></span>
                                        <span className="menu-title">My team (Coming Soon)</span>
                                    </Link> 
                                </li>*/}
              </ul>
            </div>
          </div>
        </div>
        <div className="last-section">
          {/*<div className="nav accordion-flush"  >
                        <div className="toggle-switch d-flex align-items-center">
                            <label class="switchs">
                                <input type="checkbox" checked={advancedToggle} onClick={handleClick} />
                                <span class="sliders rounds"></span>
                            </label>
                            <span className="advan-text">Advanced Mode</span>
                        </div>
                    </div>*/}

          <hr />
          <ul className="giveUsWraper">
            {/*<li className='give-us'>
                            <Link onClick={feedback}>
                                <span className="menuIcon_bx"> <img src={comsoon} alt="test" className="vector_icon" /></span>
                                <span className="give-text">My team (Coming Soon)</span>
                            </Link>
                        </li>*/}

            <li className="give-us">
              <Link onClick={feedback}>
                <span className="menuIcon_bx">
                  {" "}
                  <img src={Vector} alt="test" className="vector_icon" />
                </span>
                <span className="give-text">Give us Feedback!</span>
              </Link>
            </li>
          </ul>
        </div>
      </nav>
      <div className="grid h-screen place-items-center ">
        <Modal
          isOpen={isOpen}
          onRequestClose={() => {
            setIsOpen(false);
          }}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-width">
            <h2 className="text-right text-xl modal-text">
              <img src={infos} alt="copy" className="create-icon mb-0 me-2" />
              Contact Admin
            </h2>
            <button
              onClick={() => {
                setIsOpen(false);
              }}
              className="modal-close"
            >
              <img src={closex} alt="close" className="close-icon" />
            </button>
            <hr />
            <div className="modal-text1 text-marg">
              Contact Admin to activate Everify.
            </div>
            <div className="q-btns mt-0 mb-3 d-flex justify-content-end modal-bttn footer-bttn">
              <div class="col-sm-6" style={{ width: "67%;" }}></div>
              <button
                className="send-req-btn rounded p-2"
                onClick={() => loader === false && sendRequest()}
              >
                Send Request
              </button>
              <p
                className="cancel-bttn ms-2"
                onClick={() => {
                  setIsOpen(false);
                }}
              >
                Cancel
              </p>
            </div>
          </div>
        </Modal>
      </div>
      {loader && <Spinner />}
    </div>
  );
};
export default Sidebar;
